









import { Vue, Component } from "vue-property-decorator";
import Clipboard from "clipboard";
import MobileBanner from "@/modules/externals/components/MobileBanner.vue";
import Notifications from "@/modules/externals/components/Notifications.vue";

@Component({
  metaInfo() {
    return {
      title: "Orba One | Developer Dashboard",
    };
  },
  components: {
    MobileBanner,
    Notifications,
  },

  mounted() {
    const publicClipboard = new Clipboard("#clipboard-public-button");
    const secretClipboard = new Clipboard("#clipboard-secret-button");

    publicClipboard.on("success", () => {
      this.$notify({
        group: "tertiary",
        title: "Important message",
        text: "Public key copied.",
      });
    });
    secretClipboard.on("success", () => {
      this.$notify({
        group: "tertiary",
        title: "Important message",
        text: "Secret key copied.",
      });
    });
  },
})
export default class App extends Vue {}
